export const environment = {
  production: true,
  baseUrl:'https://www.punchdigitizing.com/digitizing_api/api/'


};
